(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('edicaoAuditoriaAplicacao', EdicaoAuditoriaAplicacaoDirective);

  function EdicaoAuditoriaAplicacaoDirective() {
    return {
      restrict: 'E',
      controller: 'AuditoriaAplicacaoEdicaoCtrl',
      templateUrl: 'views/painel_propriedade/aplicacao/edicao_auditoria.html',
      scope: {
        data: '<'
      }
    };
  }
}());
